import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const PilotContainer = styled.div<React.CSSProperties>``;

export default withAnimation(PilotContainer);
